'use strict';

import { utils } from './utils.js';
export default {
  /**
   * 是否在 iOS 客户端内
   */
  isIOS: utils.isIOS,

  /**
   * 是否是 android 新通讯模式
   */
  isKugouAndroid: utils.isKugouAndroid,

  /**
   * 是否是 android 旧通讯模式
   */
  isAndroid: utils.isAndroid,

  /**
   * 是否在客户端内
   */
  isInClient: function isInClient() {
    if (utils.isAndroid || utils.isKugouAndroid) {
      return true;
    }

    if (utils.isIOS) {
      return true;
    }

    return false;
  },

  /**
   * 调用命令号
   * 
   * @param {Number} cmd 命令号 [必填]
   * @param {Object} json 参数对象
   * @param {Function} callback 回调函数
   */
  mobileCall: function mobileCall(cmd, json, callback) {
    var jsonStr = "";

    if (json) {
      jsonStr = utils.json2Str(json);
    }

    if (!cmd) {
      console.error("请输入命令号！");
      return false;
    }

    var options = {};

    if (!!cmd) {
      options.cmd = cmd;
    }

    if (jsonStr != "") {
      options.jsonStr = jsonStr;
    }

    if (!!callback) {
      options.callback = callback;
    } // 需要特殊处理的命令号


    if (cmd && cmd == 186) {
      // 186 ack
      if (!!callback) {
        options.AndroidCallback = true;
      }
    }

    utils.callCmd(options);
  },

  /**
   * 监听客户端回调给h5的方法
   */
  KgWebMobileCall: function KgWebMobileCall(callName, callback) {
    if (!!callName) {
      try {
        var arr = callName.split('.');
        arr.reduce(function (totle, para) {
          if (!totle[para]) {
            if (para === arr[arr.length - 1]) {
              // 最后一个了
              totle[para] = function (res) {
                callback && callback(res);
              };
            } else {
              totle[para] = new Object();
            }

            return totle[para];
          } else {
            if (para === arr[arr.length - 1]) {
              // 最后一个了
              var tepm = totle[para];

              if (typeof tepm == "function") {
                totle[para] = function (res) {
                  tepm && tepm(res);
                  callback && callback(res);
                };

                return totle[para];
              } else {
                console.error("请检查，当前环境变量已注册了对象：" + callName + "，且该对象不是方法");
                return null;
              }
            } else {
              return totle[para];
            }
          }
        }, window);
      } catch (e) {}
    }
  }
};